import React from 'react';
import './status-badge.scss';

interface StatusBadgeProps {
  status: string;
  style: {
    backgroundClass: string;
    textClass: string;
  };
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, style }) => {
  return (
    <div className={`status-badge ${style.backgroundClass}`}>
      <span className={`status-text font-semibold ${style.textClass}`}>
        {status || ''}
      </span>
    </div>
  );
};
